// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MimaTable_numberedPage__VJgVr {
  width: 3rem;
  height: 3rem;
  font-size: var(--default-font-small);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--color-white);
}
.MimaTable_numberedPage__VJgVr:hover {
  border: 1px solid #2267ce;
  color: var(--color-primary);
}
.MimaTable_numberedPage__VJgVr:disabled {
  color: var(--color-grey);
  border: 1px solid var(--color-grey);
}

.MimaTable_numberPageActive__fjsM1 {
  border: 1px solid #2267ce;
  color: var(--color-primary);
  box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);
}

.MimaTable_pagination__OOOM8 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  width: 100%;
}
.MimaTable_pagination__OOOM8 > :not(:last-child) {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MimaTable.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;AADD;AAGC;EACC,yBAAA;EACA,2BAAA;AADF;AAIC;EACC,wBAAA;EACA,mCAAA;AAFF;;AAMA;EACC,yBAAA;EACA,2BAAA;EACA,+CAAA;AAHD;;AAMA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAHD;AAKC;EACC,kBAAA;AAHF","sourcesContent":["@import './variables/breakpoints';\n\n.numberedPage {\n\twidth: 3rem;\n\theight: 3rem;\n\tfont-size: var(--default-font-small);\n\tborder-radius: 0.5rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tbackground-color: var(--color-white);\n\n\t&:hover {\n\t\tborder: 1px solid #2267ce;\n\t\tcolor: var(--color-primary);\n\t}\n\n\t&:disabled {\n\t\tcolor: var(--color-grey);\n\t\tborder: 1px solid var(--color-grey);\n\t}\n}\n\n.numberPageActive {\n\tborder: 1px solid #2267ce;\n\tcolor: var(--color-primary);\n\tbox-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);\n}\n\n.pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-top: 2rem;\n\twidth: 100%;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberedPage": `MimaTable_numberedPage__VJgVr`,
	"numberPageActive": `MimaTable_numberPageActive__fjsM1`,
	"pagination": `MimaTable_pagination__OOOM8`
};
export default ___CSS_LOADER_EXPORT___;
